import React, { useRef } from 'react'
import { chatbotThemeModel, WA_carousel_template, WA_template_action_execution_data } from '../../../../../models/axiosModel';
import styles from "../../../../../assets/styles/componentStyles/carouselCard.module.scss";
import chatStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import { GlobalStyles, Grid, useMediaQuery } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import ChatLogsTemplatePreview from './chatLogsTemplatePreview';
import { secondaryColor } from '../../../../../utils/colors';


interface ChatLogsCarouselTemplatePreviewProps {
    actionData: WA_carousel_template,
    chatbotTheme: chatbotThemeModel | {},
}

const ChatLogsCarouselTemplatePreview: React.FC<ChatLogsCarouselTemplatePreviewProps> = (props) => {

    const { actionData } = props;
    const targetRef = useRef(null)
    const [searchParams] = useSearchParams()
    const isScreenBelow1000 = useMediaQuery('(max-width : 1200px) and (min-width: 0px)') || searchParams.get('screensize')


    function SampleNextArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={`${className} ${chatStyles.carouselNextArrow}`}
                style={{
                    ...style,
                    background: props.chatbotTheme?.user_msg_bg_color ? props.chatbotTheme?.user_msg_bg_color : secondaryColor,
                }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={`${className} ${chatStyles.carouselPrevArrow}`}
                style={{
                    ...style,
                    background: props.chatbotTheme?.user_msg_bg_color ? props.chatbotTheme?.user_msg_bg_color : secondaryColor,
                }}

                onClick={onClick}
            />
        );
    }
    return (
        <>
            <div
                className={`${styles.slider_container} ${globalStyles.maxWidthFull} ${chatStyles.carouselTemplateSlider}`}>
                <Slider
                    swipe={isScreenBelow1000 ? true : false}
                    arrows={true}
                    dots={false}
                    infinite={false}
                    autoplay={false}
                    variableWidth={true}
                    className={styles.chatbot_click_slider}
                    slidesToShow={1}
                    slidesToScroll={1}
                    nextArrow={<SampleNextArrow className={styles.chat_slider_next_arrow} />}
                    prevArrow={<SamplePrevArrow className={styles.chat_slider_prev_arrow} />}
                // speed={400}
                >
                    {actionData?.wa_variation_data?.map((variation: WA_template_action_execution_data, ind: number) => {
                        return (
                            <ChatLogsTemplatePreview
                                actionData={variation}
                                key={ind}
                                ref={targetRef}
                                isCarouselTemplate={true}
                            />
                        );
                    })}
                </Slider>
            </div>
        </>
    )
}

export default ChatLogsCarouselTemplatePreview
